import React from 'react';
import { lifelineLogo } from '../../../images/images';

export const orgIdKey = 'org_id';
export const orgValKey = 'org_value';
export const orgIdMapKey = 'orgIdMap';
export const defaultOrgIdValue = '1';
export const ORG_ID_PARAM = 'org_id';
export const defaultOrgKey = 'defaultOrg';

export const orgBasedHeaderUIV1 = {
  1: {
    logo: (
      <div className='tw-w-72 tw-h-12'>
        <img
          src={lifelineLogo}
          alt='blinkit lifeline'
          width='100%'
          height='100%'
        />
      </div>
    ),
    backgroundColor: 'tw-bg-white',
    searchIconColor: 'tw-bg-green-700',
  },
  3: {
    logo: (
      <div className='tw-w-96  tw-flex  tw-h-full tw-items-center tw-justify-center'>
        <div className='tw-h-16'>
          <img
            src='https://cdn.grofers.com/assets/ui/hyperpure-tag.png'
            alt='Hyperpure lifeline'
            width='100%'
            height='100%'
            className='tw-mr-2'
          />
        </div>
        <span className='tw-text-800 tw-font-medium'>Lifeline</span>
      </div>
    ),
    backgroundColor: 'tw-bg-white',
    searchIconColor: 'tw-bg-green-700',
  },
  4: {
    logo: (
      <div className='tw-w-80 tw-flex tw-h-full tw-items-center tw-justify-center'>
        <div className='tw-h-16'>
          <img
            src={
              'https://cdn.grofers.com/da/customer-delight-assets/bstr-emailer-logo.png'
            }
            alt='Bistro lifeline'
            width='100%'
            height='100%'
            className='tw-mr-2'
          />
        </div>
        <span className='tw-text-900 tw-font-medium'>Lifeline</span>
      </div>
    ),
    backgroundColor: 'tw-bg-green-400',
    searchIconColor: 'tw-bg-grey-900',
  },
};

export const orgBasedHeaderUI = {
  1: {
    logo: (
      <div className='tw-w-72 tw-h-12'>
        <img
          src={lifelineLogo}
          alt='blinkit lifeline'
          width='100%'
          height='100%'
        />
      </div>
    ),
    backgroundColor: '',
    searchIconColor: 'tw-bg-green-700',
  },
  3: {
    logo: (
      <div className='tw-w-96  tw-flex  tw-h-full tw-items-center tw-justify-center'>
        <div className='tw-h-16'>
          <img
            src='https://cdn.grofers.com/assets/ui/hyperpure-tag.png'
            alt='Hyperpure lifeline'
            width='100%'
            height='100%'
            className='tw-mr-2'
          />
        </div>
        <span className='tw-text-800 tw-font-medium'>Lifeline</span>
      </div>
    ),
    backgroundColor: 'tw-bg-white',
    searchIconColor: 'tw-bg-green-700',
  },
  4: {
    logo: (
      <div className='tw-w-80 tw-flex tw-h-full tw-items-center tw-justify-center'>
        <div className='tw-h-16'>
          <img
            src={
              'https://cdn.grofers.com/da/customer-delight-assets/bstr-emailer-logo.png'
            }
            alt='Bistro lifeline'
            width='100%'
            height='100%'
            className='tw-mr-2'
          />
        </div>
        <span className='tw-text-900 tw-font-medium'>Lifeline</span>
      </div>
    ),
    backgroundColor: 'tw-bg-green-400',
    searchIconColor: 'tw-bg-grey-900',
  },
};
